import script from "./MobileNotifStack.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileNotifStack.vue?vue&type=script&setup=true&lang=ts"

import "./MobileNotifStack.vue?vue&type=style&index=0&id=9f87923a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f87923a"]])

export default __exports__